import moment from 'moment-timezone';

export enum DATE_FORMAT {
  STANDARD = 'YYYY-MM-DD HH:mm:ss',
  NO_TIME = 'YYYY-MM-DD'
}

/**
 * Format DateTime, default format is 'YYYY-MM-DD HH:mm:ss', you can pass in a custom format.
 * @param date
 * @param options
 * @returns
 */
export const formatDate = (
  date: string,
  options?: {
    format?: DATE_FORMAT;
  }
): string => {
  if (!date) return ' - ';

  const { format = DATE_FORMAT.STANDARD } = options || {};

  const formattedDate = moment(date).format(format);
  return formattedDate;
};

export const daysTo = (date: string) => {
  const days = moment().to(moment(date));
  return days;
};
